import React, { memo } from 'react';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import type { MealGroupingType, TimingType } from '../index';
import { TIMINGS, MEAL_GROUPINGS } from '../constants';
import TimingContent from './TimingContent';

type TimingProps = {
  timing: TimingType,
  mealGrouping: MealGroupingType,
};

const useStyles = makeStyles((theme) => ({
  timing: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  iconContainer: {
    display: 'inline-block',
    marginRight: theme.spacing(1),
  },
}));

const Timing = memo(({ timing, mealGrouping }: TimingProps) => {
  const classes = useStyles();

  return (
    <Typography variant="h3" className={classes.timing}>
      <TimingContent timing={timing} />
      {timing === TIMINGS.MORNING &&
        [MEAL_GROUPINGS.ALL, MEAL_GROUPINGS.MORNING_NOON].includes(
          mealGrouping,
        ) && <TimingContent timing={TIMINGS.NOON} />}
      {timing === TIMINGS.MORNING &&
        [MEAL_GROUPINGS.ALL, MEAL_GROUPINGS.MORNING_EVENING].includes(
          mealGrouping,
        ) && <TimingContent timing={TIMINGS.EVENING} />}
      {timing === TIMINGS.NOON &&
        [MEAL_GROUPINGS.ALL, MEAL_GROUPINGS.NOON_EVENING].includes(
          mealGrouping,
        ) && <TimingContent timing={TIMINGS.EVENING} />}
    </Typography>
  );
});

export default Timing;
